var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":"","img-src":_vm.img,"img-alt":_vm.header,"img-top":""},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h6',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.header))])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }